(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sf-shipping-bar"] && !Shopify.designMode) return;
  try {
    (function(){
    function bind(){
    document.querySelectorAll('[data-sf-upgrade]:not([data-sf-bound])').forEach(function(b){
      b.setAttribute('data-sf-bound', '1');
      (function place(tries){ var row = document.querySelector('.cart-items__table-row[data-key="' + b.getAttribute('data-sf-upgrade') + '"]'); var tbody = row && row.parentNode; if (tbody) { var tr = tbody.querySelector('tr.sf-upgrade-row'); if (!tr) { tr = document.createElement('tr'); tr.className = 'sf-upgrade-row'; tr.setAttribute('role', 'presentation'); var td = document.createElement('td'); td.setAttribute('colspan', '4'); tr.appendChild(td); tbody.appendChild(tr); } tr.firstChild.appendChild(b); b.classList.add('sf-ship__upgrade--row'); } else if (tries < 40) { setTimeout(function(){ place(tries + 1); }, 100); } })(0);
      b.addEventListener('click', function(){
        b.disabled = true; b.firstChild.textContent = (b.getAttribute('data-sf-busy') || 'Adding…') + ' ';
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: b.getAttribute('data-sf-upgrade'), quantity: 2 }) })
          .then(function(r){ if (!r.ok) throw new Error('change failed'); try { sessionStorage.setItem('sf-open-cart', '1'); } catch(e){} window.location.reload(); })
          .catch(function(){ b.disabled = false; b.firstChild.textContent = (b.getAttribute('data-sf-label') || 'Add free bottle') + ' '; });
      });
    });
    }
    bind();
    document.addEventListener('cart:update', function(){ setTimeout(bind, 300); setTimeout(bind, 1500); });
    if (window.MutationObserver) new MutationObserver(function(){ bind(); }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
